<ng-container *ngTemplateOutlet="navigationLink ? link : plain"></ng-container>

<ng-template #link>
    <ng-container *ngTemplateOutlet="dragString ? draggableLink : nonDraggableLink"></ng-container>
</ng-template>

<ng-template #draggableLink>
    <div [ShDragData]="dragString">
        <a
            [shNavigationLink]="navigationLink"
            class="sh-list-row-title"
            draggable="false"
            [ngStyle]="{ 'min-width': minWidthInRem ? minWidthInRem + 'rem' : '' }"
        >
            <ng-container *ngTemplateOutlet="inner"></ng-container>
        </a>
    </div>
</ng-template>

<ng-template #nonDraggableLink>
    <a [shNavigationLink]="navigationLink" class="sh-list-row-title" [ngStyle]="{ 'min-width': minWidthInRem ? minWidthInRem + 'rem' : '' }">
        <ng-container *ngTemplateOutlet="inner"></ng-container>
    </a>
</ng-template>

<ng-template #plain>
    <header class="sh-list-row-title">
        <ng-container *ngTemplateOutlet="inner"></ng-container>
    </header>
</ng-template>

<ng-template #inner>
    <h3
        class="sh-list-row-title__title"
        [title]="title"
        [class.-sh-wrap]="wrap"
        [ShDragData]="navigationLink ? null : dragString"
        [ngStyle]="{ 'min-width': minWidthInRem ? minWidthInRem + 'rem' : '' }"
    >
        {{ title }}
    </h3>
    <small *ngIf="info" class="sh-list-row-title__info">{{ info }}</small>
</ng-template>
